'use client';

import { c as _c } from "react/compiler-runtime";
import './user-menu.scss';
import type { NavigationProps } from '@sola/schema/lib/schema.ts';
import { LogoutButton } from '../../atoms/logout-button/logout-button.tsx';
import { NavStackSimple } from '../../molecules/nav-stack-simple/nav-stack-simple.tsx';
import { SupporterIdentity } from '../../molecules/supporter-identity/supporter-identity.tsx';

/** Walk the nav tree and inject renderOverride for known content positions. */
const applyRenderOverrides = (nav: NavigationProps): NavigationProps => {
  const overriddenNav = {
    ...nav
  };
  if (nav.contentPosition?.includes('logoutLink')) {
    overriddenNav.renderOverride = <LogoutButton className="UserMenu__logout-button" title={nav.title} icon={nav.icon} />;
  }
  if (nav.link && nav.link !== '/') {
    overriddenNav.isCurrentOnChildPages = true;
  }
  if (nav.items) {
    overriddenNav.items = nav.items.map(child => applyRenderOverrides(child));
  }
  return overriddenNav;
};
export const UserMenu: React.FC<{
  userMenu: NavigationProps;
}> = t0 => {
  const $ = _c(5);
  const {
    userMenu
  } = t0;
  let t1;
  if ($[0] !== userMenu) {
    t1 = applyRenderOverrides(userMenu);
    $[0] = userMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enhancedMenu = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SupporterIdentity variant="full" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== enhancedMenu) {
    t3 = <div className="UserMenu">{t2}<NavStackSimple rootNav={enhancedMenu} /></div>;
    $[3] = enhancedMenu;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};